import { IonButton, IonButtons, IonCard, IonCardContent, IonCardTitle, IonCol, IonContent, IonGrid, IonIcon, IonModal, IonPage, IonPopover, IonRow, IonText, IonTitle, isPlatform, useIonActionSheet, useIonRouter } from '@ionic/react';
import { ellipsisHorizontal, ellipsisVertical, exitOutline } from 'ionicons/icons';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { RootState } from '../../data/store';

import './Start.scss';
import { useEffect, useRef, useState } from 'react';
import { App } from '@capacitor/app';
import ArticleService from '../../data/services/ArticleService';
import { BarcodeScanner } from '@capacitor-mlkit/barcode-scanning';
import { defaultScannerOptions, installGoogleBarcodeScannerModule, requestPermissions, urlToIdent } from '../../components/mlKitScanner/qrCodeHelper';
import MLKitScanner from '../../components/mlKitScanner/MLKitScanner';
import { Header, MainPopoverMenu } from '../../components';
import { useTranslation } from 'react-i18next';



const Start: React.FC<RouteComponentProps> = ({ history }: RouteComponentProps) => {
  const darkMode: boolean = useSelector((state: RootState) => state.user.darkMode)
  /* const isLoggedIn: boolean = useSelector((state: RootState) => state.auth.isAuthenticated) */
  const [presentSheet] = useIonActionSheet();
  const [scanActive, setScanActive] = useState<boolean>(false);
  const modal = useRef<HTMLIonModalElement>(null!);
  const ionRouter = useIonRouter();
  const [isScannerSupported, setIsScannerSupported] = useState<boolean>(false);
  const popover = useRef<HTMLIonPopoverElement>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const { t, i18n } = useTranslation();

  const openPopover = (e: any) => {
    popover.current!.event = e;
    setPopoverOpen(true);
  };

  document.addEventListener('ionBackButton', (ev) => {
    /* @ts-ignore */
    ev.detail.register(-1, () => {
      if (!ionRouter.canGoBack() && !scanActive) {
        App.exitApp();
      }
    });
  });

  useEffect(() => {
    ArticleService.getArticlesCuttingParamsStd();
  }, [])

  useEffect(() => {
    BarcodeScanner.isSupported().then((res) => {
      setIsScannerSupported(res.supported)
    }).catch(() => { })

  }, [])


  //QR Code
  const startScan = async () => {
    const granted = await requestPermissions();
    if (!granted) {
      //TODO: display error info
      return
    }
    if (isPlatform("android")) {
      const { available } = await BarcodeScanner.isGoogleBarcodeScannerModuleAvailable();
      if (!available) {
        await installGoogleBarcodeScannerModule()
      }
    }
    // Add the `barcodeScanned` listener
    await BarcodeScanner.addListener(
      'barcodesScanned',
      async result => {
        stopScan()
        handleQRCodeResult(result.barcodes[0].displayValue); // TODO: nach cap 7 update üebrprüfen was alles in array ist
      },
    )
    // Start the barcode scanner
    setScanActive(true)
    document.querySelector('body')?.classList.add('barcode-scanner-active');
    await BarcodeScanner.startScan(defaultScannerOptions);
  }

  const stopScan = async () => {
    document.querySelector('body')?.classList.remove('barcode-scanner-active');
    setScanActive(false)
    await BarcodeScanner.removeAllListeners();

    await BarcodeScanner.stopScan();
  };



  const handleQRCodeResult = (url_string: string) => {
    let { params, searchStr } = urlToIdent(url_string)

    let connector = i18n.language === "en" ? " and " : " und "

    presentSheet({
      header: t("QR-Code gescannt"),
      subHeader: t('Welche Daten möchten Sie von ... sehen?', { params: params.join(connector) }),
      buttons: [
        {
          text: t("Preise / Verfügbarkeit"),
          handler: () => { history.push(`/tabs/article/productPriceAvail/${searchStr}`) }
        },
        {
          text: t("Schnittwerte"),
          handler: () => { history.push(`/tabs/calculator/preselection/${searchStr}`) }
        },
        {
          text: t("Abbrechen"),
          role: 'cancel',
          data: {
            action: 'cancel',
          },
        },
      ],
      onDidDismiss: ({ detail }) => console.log(detail),
    })
  }


  return (
    <IonPage>
      <Header>
        <IonTitle>Start</IonTitle>
        <IonButtons slot="primary">
          <IonButton id="header-menu-button" onClick={openPopover}>
            <IonIcon slot="icon-only" ios={ellipsisHorizontal} md={ellipsisVertical} />
          </IonButton>
        </IonButtons>
      </Header>

      <IonContent fullscreen className={scanActive ? 'hideBg' : ''}>
        {/* <div className='specialHachenbachBackgroundCard'  >
          <div className='specialHachenbachBackgroundCardContent'>
            <div style={{ marginTop: 75 }} className='hachenbachLogo'>
              <img src={darkMode ? "./assets/images/logo-big.png" : "./assets/images/logo-big-dark.png"} alt="Hachenbach Logo" />
            </div>
          </div>
        </div> */}

        <IonGrid fixed={true} className="mainContent">
          <IonRow /* style={{ marginTop: 160 }} */>
            <IonCol size='12'>
              <IonCard className='logoCard'>

                <img src={darkMode ? "./assets/images/logo-big.png" : "./assets/images/logo-big-dark.png"} alt={t("Hachenbach Logo")} />

              </IonCard>
            </IonCol>

            <IonCol size="6">
              <IonCard className='startCard internalLink' onClick={() => history.push("calculator/form")}>
                <IonCardContent>
                  <div className='startCardContent'>
                    <div>
                      <IonCardTitle color={'primary'}>{t("Kalkulator")}</IonCardTitle>
                      <IonText>{t('Schnittwerte ermitteln')}</IonText>
                    </div>
                    <div>
                      <img src={darkMode ? "./assets/images/start-icons/icon_calculator_darkmode.png" : "./assets/images/start-icons/icon_calculator.png"} alt={t("Kalkulator Icon")} />
                    </div>
                  </div>
                </IonCardContent>
              </IonCard>
            </IonCol>

            <IonCol size="6">
              <IonCard className='startCard internalLink' onClick={() => history.push("article/toolfinder")}>
                <IonCardContent>
                  <div className='startCardContent'>
                    <div>
                      <IonCardTitle color={'primary'}>{t("Toolfinder")}</IonCardTitle>
                      <IonText>{t("Fräser ermitteln")}</IonText>
                    </div>
                    <div>
                      <img src={darkMode ? "./assets/images/start-icons/icon_toolfinder_darkmode.png" : "./assets/images/start-icons/icon_toolfinder.png"} alt={t("Toolfinder Icon")} />
                    </div>
                  </div>
                </IonCardContent>
              </IonCard>
            </IonCol>

            <IonCol size="6">
              <IonCard disabled={!isScannerSupported} className='startCard internalLink' onClick={() => startScan()}>
                <IonCardContent>
                  <div className='startCardContent'>
                    <div>
                      <IonCardTitle color={'primary'}>{t("QR-Code")}</IonCardTitle>
                      <IonText>{t("Artikel scannen")}</IonText>
                    </div>
                    <div>
                      <img src={darkMode ? "./assets/images/start-icons/icon_qr-code_darkmode.png" : "./assets/images/start-icons/icon_qr-code.png"} alt={t("QR Icon")} />
                    </div>
                  </div>
                </IonCardContent>
              </IonCard>
            </IonCol>

            <IonCol size="6">
              <IonCard className='startCard externalLink' target='_blank' rel='noreferrer' href="https://www.hachenbach.de">
                <IonCardContent>
                  <div className='startCardContent'>
                    <div>
                      <IonCardTitle color={'primary'}>{t("Website")}</IonCardTitle>
                      <IonText>{t("Hachenbach")}</IonText>
                    </div>
                    <div>
                      <img src={darkMode ? "./assets/images/start-icons/icon_website_darkmode.png" : "./assets/images/start-icons/icon_website.png"} alt={t("Webseite Icon")} />
                      <div className='externalIcon'>
                        <IonIcon size="small" icon={exitOutline} color={darkMode ? "medium" : "primary"} />
                      </div>
                    </div>
                  </div>
                </IonCardContent>
              </IonCard>
            </IonCol>

            <IonCol size="6">
              <IonCard className='startCard externalLink' target='_blank' rel="noreferrer" href='https://hachenbach-toolshop.de/'>
                <IonCardContent>
                  <div className='startCardContent'>
                    <div>
                      <IonCardTitle color={'primary'}>{t("Toolshop")}</IonCardTitle>
                      <IonText>{t("Hachenbach")}</IonText>
                    </div>
                    <div>
                      <img src={darkMode ? "./assets/images/start-icons/icon_toolfinder_darkmode.png" : "./assets/images/start-icons/icon_toolfinder.png"} alt={t("Toolshop Icon")} />
                      <div className='externalIcon'>
                        <IonIcon size="small" icon={exitOutline} color={darkMode ? "medium" : "primary"} />
                      </div>
                    </div>
                  </div>
                </IonCardContent>
              </IonCard>
            </IonCol>

            <IonCol size="6">
              <IonCard className='startCard externalLink' href='https://pim.hachenbach.de/qr/hmruecknahme' rel='noreferrer' target="_blank">
                <IonCardContent>
                  <div className='startCardContent'>
                    <div>
                      <IonCardTitle color={'primary'}>{t("HM-Rücknahme")}</IonCardTitle>
                      <IonText>{t("Ankauf")}</IonText>
                    </div>
                    <div>
                      <img src={darkMode ? "./assets/images/start-icons/icon_hm-schrott_darkmode.png" : "./assets/images/start-icons/icon_hm-schrott.png"} alt={t("HM-Rücknahme Icon")} />
                      <div className='externalIcon'>
                        <IonIcon size="small" icon={exitOutline} color={darkMode ? "medium" : "primary"} />
                      </div>
                    </div>
                  </div>
                </IonCardContent>
              </IonCard>
            </IonCol>


          </IonRow>
        </IonGrid>

      </IonContent>
      {/* Scanner */}
      <IonModal ref={modal} isOpen={scanActive} className="qrcodeScannerModal" onWillDismiss={() => stopScan()} canDismiss={true}>
        <MLKitScanner modal={modal} />
      </IonModal>
      <IonPopover ref={popover} isOpen={popoverOpen} onDidDismiss={() => setPopoverOpen(false)}>
        <MainPopoverMenu dismiss={() => setPopoverOpen(false)} />
      </IonPopover>
    </IonPage >
  );
};

export default Start;
